import React from 'react'
import { BrightspotRouting } from '@fs/zion-cms'
import zionDebug from '@fs/zion-debug'
import ErrorBoundary from '@fs/zion-error-boundary'
import { NotFound, Route, Switch, useLocation } from '@fs/zion-router'

import SiteRoute from './components/SiteRoute'
import useApac from './hooks/useApac'
import getRegionRoutes from './regions/getRegionRoutes'

const DevHomePage = React.lazy(() => import('./pages/DevHomePage'))
const MemoriesPage = React.lazy(() => import('./pages/MemoriesPage'))
const AboutPage = React.lazy(() => import('./pages/AboutPage'))

const debug = zionDebug('apac:App')

export default function App() {
  const { site } = useApac()
  debug(`site: ${site || 'not set'}`)
  const location = useLocation()
  debug('location', location)
  const { search } = location

  const urlSearchParams = new URLSearchParams(search)
  const previewId = urlSearchParams.get('previewId') || undefined
  if (previewId && site) {
    return <BrightspotRouting site={site} />
  }

  return (
    <ErrorBoundary>
      <Switch>
        {!site && <SiteRoute exact path="/" component={DevHomePage} notProdReady />}
        {!site && <SiteRoute exact path="/memories" component={MemoriesPage} notProdReady />}
        {!site && <SiteRoute exact path="/about" component={AboutPage} notProdReady />}
        {/* create the region specific routes */}
        {getRegionRoutes(site)}
        {/* handle any supported Brightspot pages */}
        {site && <BrightspotRouting site={site} />}
        <Route component={NotFound} />
      </Switch>
    </ErrorBoundary>
  )
}
